module.exports = __webpack_public_path__ + "img/linkedin.bfdf0871.svg";